import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Santa Rosa, CA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Santa Rosa can take 2–6 months. For wine industry professionals with trade show deadlines, retirees planning European cruises, and mission teams with fixed departure dates, that timeline is simply not viable.",
  },
  {
    q: "What is the nearest passport agency to Santa Rosa?",
    a: "The San Francisco Passport Agency is located at 95 Hawthorne St, Suite 600, San Francisco, CA 94105 — about 55 miles south of Santa Rosa. Getting there and securing a same-day appointment is a full-day commitment. Fast Passport Center provides the simple alternative: start online from your Santa Rosa home, ship overnight, and receive your passport within your selected timeframe without leaving Sonoma County.",
  },
  {
    q: "Can Oakmont Village retirement residents get expedited passport renewal?",
    a: "Absolutely. Oakmont Village residents are one of our most common client types in the Santa Rosa area. Many residents hold passports that expired during the pandemic travel lull and are now planning European river cruises, Mediterranean tours, or Latin American adventures. We walk you through the entire process and make renewal as simple as possible. Start online and ship overnight — no need to drive to San Francisco.",
  },
  {
    q: "Can wine industry professionals get passports fast for Vinexpo or harvest trips?",
    a: "Yes — and this is one of the most common urgent passport scenarios we see from Sonoma County. Wine trade show invitations and harvest consultation trips often arrive 2–4 weeks before departure. We regularly process expedited renewals for winemakers, vineyard owners, and hospitality executives on compressed timelines. Contact us as soon as travel is confirmed.",
  },
  {
    q: "Can SRJC students get a passport fast for study-abroad programs?",
    a: "Yes. SRJC study-abroad programs and international service-learning trips are well within our expedited processing capabilities. First-time applicants (many students) must visit an acceptance clerk in person. We provide a personalized checklist with exact Santa Rosa locations so you know exactly where to go. After your clerk visit, ship your documents overnight and we handle the rest.",
  },
  {
    q: "Do I need to make an in-person visit to use Fast Passport Center?",
    a: "For most renewals, no. You can start online, follow the checklist, and ship documents overnight. First-time applicants and children (under 16) must visit an acceptance clerk in person to submit their initial application. We provide a personalized checklist with exact Sonoma County acceptance clerk locations so you know exactly where to go and what to bring.",
  },
  {
    q: "Does Fast Passport Center serve Petaluma, Healdsburg, and Windsor?",
    a: "Yes — all of Sonoma County is within our service area. Petaluma, Healdsburg, Windsor, Rohnert Park, Sebastopol, and all surrounding communities can use our service. Since we operate remotely, your physical location within Sonoma County does not affect processing speed. Ship your documents overnight from anywhere in the county.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function SantaRosaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Santa Rosa and Sonoma County travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}